import React, { Component } from 'react';
import { SearchTypes } from '../../constants/CentricConstants';
import ListItem from '../Asset/AssetListItem';
import ListView from '../Common/ListView.react';
import ModuleActions from '../../actions/ModuleActionCreator';
import { browserHistory } from 'react-router';

class ResourceSearch extends Component {

    componentDidMount() {
        this.searchAssets = this.searchAssets.bind(this);
        if (this.props.location.query.searchTerm && this.props.location.query.searchTerm.length > 2) {
            this.searchAssets(this.props.location.query.searchTerm);
        }
    }

    render() {
        return (
            <ListView
                title="Resources"
                items={[]}
                searchAction={this.searchAssets}
                searchMode={true}
                searchModeOnly={true}
                searchType={SearchTypes.RESOURCES}
                itemDecorator={ListItem}
                backTo="/dashboard"
            />
        );
    }

    searchAssets(searchTerm) {
        if (searchTerm && searchTerm.length > 2) {
            ModuleActions.searchMedia(searchTerm, { type: 'resource' });
            browserHistory.replace(`${this.props.location.pathname}?searchTerm=${searchTerm}`);
        }
    }
}

export default ResourceSearch;
